import { LoadingInterceptor } from './loading.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { OverrideParameterInterceptor } from './override-parameter.interceptor';

/**
 *  Interceptors:
 *    Angular's interceptors flow in the order you provide them.
 *    If you provide interceptors A, then B, then C,
 *    then requests will flow in A->B->C and responses will flow out C->B->A.
 */
export const interceptors = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true,
  },
  OverrideParameterInterceptor,
  {
    provide: HTTP_INTERCEPTORS,
    useExisting: OverrideParameterInterceptor,
    multi: true,
  }
];
